// /src/renderer/layout/MainShell/MainShell.tsx
import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';
import './LoginShell.scss';

class LoginShell extends Component {
  render(): React.JSX.Element {
    return (
      <div className="login-shell">
        <div className="content-area">
          {/* 하위 라우트(예: BrowserPage, SettingsPage 등)가 이 영역에 렌더링됩니다 */}
          <Outlet />
        </div>
      </div>
    );
  }
}

export default LoginShell;
